module.exports = __webpack_public_path__ + "static/media/Stripe.e5201144.svg";